import SEO from '../components/SEO';
import { PageHero } from '../components/Reveal';
import { CONTACT } from '../data/config';

const SECTIONS = [
  {
    title: 'About This Website',
    body: 'CareerWithRaaj is a career guidance, career planning, and skill development platform. The content on this website — including career paths, roadmaps, and resources — is provided for general guidance and informational purposes.',
  },
  {
    title: 'Not Professional Advice',
    body: 'Career guidance is inherently personal. While we work hard to provide accurate, practical, and current information, decisions about your education and career remain yours. We recommend discussing major decisions with your family and verifying details with official institutions.',
  },
  {
    title: 'Accuracy of Information',
    body: 'Course details, career paths, and industry information change over time. We strive for accuracy but do not guarantee that all information is complete or current. Always confirm admission criteria, fees, and requirements directly with the relevant institutions.',
  },
  {
    title: 'Consultations & Paid Services',
    body: 'Consultation bookings, plans, and payments (when enabled) are subject to the terms shared at the time of booking. Prices shown as placeholders will be confirmed before any payment is collected.',
  },
  {
    title: 'Intellectual Property',
    body: 'All content on this website — text, design, roadmaps, and resources — belongs to CareerWithRaaj and may not be reproduced without permission. Free resources are for personal use only.',
  },
  {
    title: 'Acceptable Use',
    body: 'You agree to use this website lawfully and respectfully — no misuse of forms, no scraping, and no attempts to disrupt the service.',
  },
  {
    title: 'Changes to These Terms',
    body: 'We may update these Terms & Conditions as the platform evolves. Continued use of the website after changes means you accept the updated terms.',
  },
];

const Terms = () => (
  <main data-testid="terms-page">
    <SEO
      title="Terms & Conditions | CareerWithRaaj"
      description="The terms governing the use of the CareerWithRaaj website and services."
    />
    <PageHero overline="Legal" title="Terms & Conditions" description="Last updated: July 2026. The simple, honest terms for using CareerWithRaaj." />
    <section className="bg-white py-24">
      <div className="mx-auto max-w-3xl space-y-10 px-6 md:px-12">
        {SECTIONS.map((s, i) => (
          <div key={s.title} data-testid={`terms-section-${i + 1}`}>
            <h2 className="font-display text-xl font-semibold text-navy md:text-2xl">
              {String(i + 1).padStart(2, '0')}. {s.title}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">{s.body}</p>
          </div>
        ))}
        <p className="rounded-2xl border border-line bg-mist p-6 text-sm text-slate-600">
          Questions about these terms? Reach us at <code className="font-mono text-coral">{CONTACT.email}</code>.
        </p>
      </div>
    </section>
  </main>
);

export default Terms;
